export const environment = {
  production: true,
  API: 'https://authority-labs-api.azurewebsites.net/api',
  hmr: false,
  // Replaced with the commit SHA by the deploy-ui workflow.
  buildVersion: '620573ae20d8377ebc1a343bfbddb2a8a450608f',
  newRelic: {
    enabled: true
  }
};
